// Single place for validation + payload + submit

// --- helpers ---
const EMAIL_RX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
const toStr = v => String(v ?? '').trim()

// permissive phone normalization: keep digits and leading '+'
const normalizeTel = v => {
	const s = toStr(v)
	if (!s) return ''
	const plus = s.trim().startsWith('+') ? '+' : ''
	const digits = s.replace(/\D+/g, '')
	return digits ? plus + digits : ''
}

// --- validation ---
export const validateLead = f => {
	const errors = []
	const name = toStr(f.customerName)

	if (!name) errors.push('Full name is required.')

	return { ok: errors.length === 0, errors }
}

// --- payload builder (normalize/trim fields) ---
export const buildPayload = f => ({
	customerName: toStr(f.customerName),
	customerEmail: toStr(f.customerEmail).toLowerCase(),
	customerTel: normalizeTel(f.customerTel),
	source: toStr(f.source),
	campaign: toStr(f.campaign),
	status: toStr(f.status),
	note: toStr(f.note),
})

// --- submit (await service for consistent error surfacing) ---
export const submitLead = async (LeadsService, form) => {
	const payload = buildPayload(form)
	return await LeadsService.createLead(payload)
}
